const fetchDataPost = async (URL, token, obj) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_HOST_BASE_URL}/${URL}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(obj),
      }
    );

    if (response.ok) {
      const json = await response.json();
      return {
        data: json,
        success: true,
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (err) {
    return {
      success: false,
      message: err.message,
    };
  }
};
export default fetchDataPost;
